import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Badge, Button } from "@mm/metx-design-system";
import "./marketplace-hero.scss";

const YOUTUBE_TUTORIALS_URL =
  "https://www.youtube.com/watch?v=fLS_4-62GNg&list=PLenoBIWRMzlVMjFJHVrLhStIji21prrhG&index=2";

export function MarketplaceHero() {
  return (
    <aside
      className="marketplace-hero"
      aria-label={t({
        id: "marketplace.hero.aria-label",
        message: "Video tutorials",
      })}
    >
      <div className="marketplace-hero__content">
        <div className="marketplace-hero__labels">
          <Badge color="lila" className="marketplace-hero__badge">
            <Trans id="marketplace.hero.badge">Video tutorials</Trans>
          </Badge>
          <span className="marketplace-hero__channel">
            <Trans id="marketplace.hero.channel">YouTube Channel</Trans>
          </span>
        </div>
        <h2 className="marketplace-hero__title">
          <Trans id="marketplace.hero.title">Get started with MetX</Trans>
        </h2>
        <p className="marketplace-hero__description">
          <Trans id="marketplace.hero.description">
            Learn how to get the most out of MetX with step-by-step video tutorials. From getting started to advanced
            features, our YouTube channel covers weather data visualization, API integration, custom dashboards, and
            more. Perfect for new and experienced Meteomatics users.
          </Trans>
        </p>
        <Button
          className="marketplace-hero__cta"
          variant="cta"
          rightIcon={
            <span className="material-symbols-outlined" aria-hidden>
              open_in_new
            </span>
          }
          onClick={() => window.open(YOUTUBE_TUTORIALS_URL, "_blank", "noopener,noreferrer")}
        >
          <Trans id="marketplace.hero.cta">Browse tutorials</Trans>
        </Button>
      </div>
      <div className="marketplace-hero__image-wrap">
        <img className="marketplace-hero__image" src="/marketplace-hero.png" alt="Get started with MetX" aria-hidden />
      </div>
    </aside>
  );
}
